<template>
    <!-- Loading -->
    <div class="vld-parent">
        <loading v-model:active="isLoading" :is-full-page="true" :height="128" :width="128" />
    </div>

    <!-- Form -->
    <form @submit.prevent="store" class="form-content">
        <div class="form-content-inner">
            <control type="hidden" v-model="progexctime.id" :hasError="!!errors.id" id="id" />

            <div class="form-col">
                <field :label="$t('progexctime.programme_name')" class="w-full md:ml-2 mb-2 md:mb-0"
                :hasError="errors.programme_id">
                    <control :options="programmeOptions" :placeholder="$t('progexctime.placeholder.programme_name')"
                    v-model="progexctime.programme_id" id="programme_id" :hasError="!!errors.programme_id" />
                </field>
            </div>

            <div class="form-col">
                <field :label="$t('progexctime.description')" class="w-full md:mr-2 mb-2 md:mb-0"
                    :hasError="errors.description">
                    <control type="text" :placeholder="$t('progexctime.placeholder.description')"
                        v-model="progexctime.description" :hasError="!!errors.description" id="description" />
                </field>
            </div>

            <div class="form-col">
                <field :label="$t('progexctime.remarks')" class="w-full md:mr-2 mb-2 md:mb-0"
                    :hasError="errors.remarks">
                    <control type="text" :placeholder="$t('progexctime.placeholder.remarks')"
                        v-model="progexctime.remarks" :hasError="!!errors.remarks" id="remarks" />
                </field>
            </div>

            <div class="form-col">
                <field :label="$t('progexctime.start_date')" class="w-full md:mr-2 mb-2 md:mb-0"
                    :hasError="errors.start_date">
                    <control type="date" v-model="progexctime.start_date" :hasError="!!errors.start_date"
                        id="start_date" />
                </field>
            </div>

            <div class="form-col">
                <field :label="$t('progexctime.end_date')" class="w-full md:mr-2 mb-2 md:mb-0"
                    :hasError="errors.end_date">
                    <control type="date" v-model="progexctime.end_date" :hasError="!!errors.end_date" id="end_date" />
                </field>
            </div>

            <div class="form-col">
                <field :label="$t('progexctime.start_work_time')" class="w-full md:mr-2 mb-2 md:mb-0"
                    :hasError="errors.start_work_time">
                    <control type="time" v-model="progexctime.start_work_time" :hasError="!!errors.start_work_time"
                        id="start_work_time" />
                </field>
            </div>

            <div class="form-col">
                <field :label="$t('progexctime.end_work_time')" class="w-full md:mr-2 mb-2 md:mb-0"
                    :hasError="errors.end_work_time">
                    <control type="time" v-model="progexctime.end_work_time" :hasError="!!errors.end_work_time"
                        id="end_work_time" />
                </field>
            </div>

            <div class="form-col">
                <field :label="$t('progexctime.consider_as_time')" class="w-full md:mr-2 mb-2 md:mb-0"
                    :hasError="errors.consider_as_overtime">
                    <check-radio-picker
                        type="radio"
                        required
                        name="consider_as_time"
                        v-model="progexctime.consider_as_overtime"
                        :hasError="!!errors.consider_as_overtime"
                        :options="{ true: 'Yes', false: 'No' }"
                        style="display: flex; flex-wrap: nowrap; gap: 1.25rem">
                    </check-radio-picker>
                </field>
            </div>

            <div class="buttons-submit transition-colors duration-1000"
                :class="darkMode ? 'bg-darkmode-base' : 'bg-gray-100'">
                <jb-buttons class="buttons-action-submit">
                    <jb-button type="submit" color="info" :icon="mdiCheckBold" :label="$t('finance.button.btnSubmit')"
                        class="form-submit-btn" />
                    <jb-button type="button" color="info" outline :label="$t('finance.button.btnReset')"
                        class="form-noicon-btn btn-reset" @click="reset()" />
                </jb-buttons>
            </div>
        </div>
    </form>
</template>

<script>
/* eslint-disable */
import { ref, reactive, onMounted, onBeforeMount, watch, watchEffect } from 'vue'
import axios from 'axios'
import { mdiBallot, mdiCheckBold } from '@mdi/js'
import Control from '@/components/Control'
import JbButton from '@/components/JbButton'
import JbButtons from '@/components/JbButtons'
import Field from '@/components/Field'
import CheckRadioPicker from '@/components/CheckRadioPicker'
import { useToast } from 'vue-toastification'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
    name: 'ProgexctimeForm',
    components: {
        Field,
        Control,
        Loading,
        JbButton,
        JbButtons,
        CheckRadioPicker
    },
    props: {
        showEdit: {
            type: Boolean,
            default: false
        },
        propClass: {
            type: Object,
            default: () => ({ empty: true })
        }
    },
    emits: ['close-modal', 'submit', 'reset-modal'],
    setup(props, { emit }) {
        const titleStack = ref(['Admin', 'Forms'])
        const isLoading = ref(false)
        const toast = useToast()
        const router = useRouter()
        const errors = ref({})
        const programmeOptions = ref([])
        const str = useStore()
        const userlogin = localStorage.getItem('name')

        const progexctime = reactive({
            id: '',
            programme_id: '',
            description: '',
            remarks: '',
            start_date: '',
            end_date: '',
            start_work_time: '',
            end_work_time: '',
            consider_as_overtime: false,
            created_by: '',
            updated_by: ''
        })

        const reset = () => {
            progexctime.programme_id = ''
            progexctime.description = ''
            progexctime.remarks = ''
            progexctime.start_date = ''
            progexctime.end_date = ''
            progexctime.start_work_time = ''
            progexctime.end_work_time = ''
            progexctime.consider_as_overtime = false
        }

        const store = async () => {
            isLoading.value = true
            const url = props.showEdit ? `progexctime/` + progexctime.id : 'progexctime'
            const method = props.showEdit ? 'PUT' : 'POST'

            if (method === 'POST') {
                progexctime.created_by = userlogin
            } else {
                progexctime.updated_by = userlogin
            }

            await axios({
                method,
                url,
                data: progexctime
            })
                .then(response => {
                    if (response.data.success) {
                        emit('reset-modal')
                        emit('close-modal')
                        toast.success(response.data.message)
                    } else {
                        errors.value = response.data.messages || response.data.errors
                        toast.error(response.data.messages || 'Failed to save data')
                    }
                    isLoading.value = false
                    if (!props.showEdit) reset() // Reset hanya untuk create
                })
                .catch(error => {
                    if (error.response) {
                        errors.value = error.response.data.errors || {}
                        toast.error(error.response.data.message || 'Error occurred')
                        console.log('Error response:', JSON.stringify(error.response.data))
                    } else if (error.message) {
                        toast.error(error.message)
                        console.log('Error message:', JSON.stringify(error.message))
                    }
                    isLoading.value = false
                })
        }

        const getProgramme = async () => {
            isLoading.value = true
            await axios
            .get('programme')
            .then(response => {
                programmeOptions.value = response.data.data
                isLoading.value = false
            }).catch(error => {
                toast.error(error.response.data, { timeout: 5000 })
                console.log(error)
                isLoading.value = false
            })
        }

        onMounted(() => {
            getProgramme()
        })

        watchEffect(() => {
            const newProgexctime = props.propClass

            if (!props.showEdit) {
                // 
            }

            Object.assign(progexctime, newProgexctime)
        })

        return {
            isLoading,
            titleStack,
            progexctime,
            programmeOptions,
            errors,
            mdiBallot,
            mdiCheckBold,
            getProgramme,
            store,
            reset,
            router,
            toast,
            userlogin,
            str
        }
    },
    methods: {
        clearForm() {
            this.progexctime = reactive({
                id: '',
                programme_id: '',
                description: '',
                remarks: '',
                start_date: '',
                end_date: '',
                start_work_time: '',
                end_work_time: '',
                consider_as_overtime: false,
                created_by: '',
                updated_by: ''
            })
        },
        onChange: function (programme_id, event) {
            if (event.target.value) {
                progexctime.programme_id = event.target.value
            }
        }
    }
}
</script>
